/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import React, { useEffect, useState } from "react";
import { IUserIRoute } from "../../../../../../generated/Api";
import { SpaceBetween } from "../../../../../../styles/general";
import Loading from "../../../../../Loading";
import SortableList from "../../../../../SortableList/SortableList";
import Switch from "../../../../../Switch";
import CreateTimeCard from "./CreateTimeCard";
import TimeCard from "./TimeCard";

const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 25px 0px;
  padding: 0px 22px;
  width: 600px;
  height: fit-content;

  @media screen and (max-width: 600px) {
    width: 100%;
  }
`;

const Title = styled.div`
  color: #2f2f2f;
  font-weight: 600;
  margin-bottom: 5px;
`;

const AddButton = styled.div`
  color: #fb972e;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  margin-top: 15px;
`;

const CheckDescription = styled.div`
  margin-left: 5px;
  font-size: 14px;
  color: #2f2f2f;
`;

const TitleDescription = styled.div`
  color: #bebebe;
  font-size: 13px;
`;

const SubjectDescription = styled.div`
  color: #707070;
  font-size: 14px;
`;

export const FavoriteTimesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  grid-gap: 10px;
`;

interface Props {
  user: IUserIRoute;
  setUser: (u: IUserIRoute) => void;
}

export default function FavoriteTimeSettings(props: Props) {
  const { user, setUser } = props;
  const [add, setAdd] = useState(false);
  const [favoriteScheduleTimesArray, setFavoriteScheduleTimesArray] = useState<
    string[]
  >([]);
  const [flag, setFlag] = useState(false);

  useEffect(() => {
    if (!user && !user.options.favoriteScheduleTimes.length) return;
    setFavoriteScheduleTimesArray(user.options.favoriteScheduleTimes);
    setFlag(!flag);
  }, [user.options.favoriteScheduleTimes]);

  async function handleUpdateFavoriteScheduleTime(
    newFavoriteTimesOrder: string[]
  ) {
    if (!newFavoriteTimesOrder.length) return;

    setFavoriteScheduleTimesArray(newFavoriteTimesOrder);

    setUser({
      ...user,
      options: {
        ...user.options,
        favoriteScheduleTimes: newFavoriteTimesOrder,
      },
    });
  }

  return (
    <FlexColumn>
      <Title>Favorite Times</Title>
      <SpaceBetween
        css={css`
          margin-bottom: 15px;
        `}
      >
        <SubjectDescription>Enable favorite times</SubjectDescription>
        <Switch
          toggled={user.options.enableFavoriteTimes}
          whenToggled={(vle) =>
            setUser({
              ...user,
              options: { ...user.options, enableFavoriteTimes: vle },
            })
          }
        />
      </SpaceBetween>

      {user.options.enableFavoriteTimes && (
        <>
          <FavoriteTimesWrapper key={`${flag}`}>
            {user.options?.favoriteScheduleTimes ? (
              <SortableList
                items={favoriteScheduleTimesArray}
                onDragEnd={(items: string[]) => {
                  handleUpdateFavoriteScheduleTime(items);
                }}
              >
                {favoriteScheduleTimesArray.map((fTime, index) => {
                  return (
                    <TimeCard
                      key={fTime + index}
                      id={index.toString()}
                      time={fTime}
                      edit={(date) => {
                        let newFavoriteScheduleTimes =
                          user.options.favoriteScheduleTimes.map((dd, id) =>
                            id === index ? date : dd
                          );

                        setUser({
                          ...user,
                          options: {
                            ...user.options,
                            favoriteScheduleTimes: newFavoriteScheduleTimes,
                          },
                        });
                      }}
                      delete={() => {
                        let newFavoriteScheduleTimes =
                          user.options.favoriteScheduleTimes.filter(
                            (dd, id) => id !== index
                          );

                        setUser({
                          ...user,
                          options: {
                            ...user.options,
                            favoriteScheduleTimes: newFavoriteScheduleTimes,
                          },
                        });
                      }}
                    />
                  );
                })}
              </SortableList>
            ) : (
              <Loading />
            )}
          </FavoriteTimesWrapper>

          {add && (
            <CreateTimeCard
              addTime={(date) => {
                setUser({
                  ...user,
                  options: {
                    ...user.options,
                    favoriteScheduleTimes: [
                      ...user.options.favoriteScheduleTimes,
                      date,
                    ],
                  },
                });
                setAdd(false);
              }}
            />
          )}

          <AddButton onClick={() => setAdd(!add)}>
            {!add
              ? favoriteScheduleTimesArray.length
                ? "+ Click to add another favorite send time"
                : "+ Click to add your first favorite send time"
              : "Close"}
          </AddButton>
        </>
      )}
    </FlexColumn>
  );
}
